{
    "name": "paintball-client",
    "version": "1.3.1",
    "description": "Paintball in Wonderland Engine.",
    "main": "js/index.js",
    "type": "module",
    "module": "js/index.js",
    "scripts": {
        "build": "tsc",
        "dev": "tsc --watch",
        "update-discord": "wl-cloud page update -c deployment-discord.json",
        "deploy:viverse": "wl-cloud page update --config ./deployment-viverse.json --skipConfigUpdate --noThreads"
    },
    "keywords": [
        "wonderland-engine"
    ],
    "dependencies": {
        "@discord/embedded-app-sdk": "^1.9.0",
        "@heyvr/sdk-types": "^1.1.8",
        "@wonderlandcloud/client": "0.2.0-wip10",
        "@wonderlandengine/api": ">=1.3.0 <1.4.0",
        "@wonderlandengine/components": "^1.2.3",
        "@wonderlandengine/react-ui": "^0.2.2",
        "@wonderlandengine/spatial-audio": "^1.2.2",
        "gameanalytics": "^4.4.7",
        "gl-matrix": "^3.4.3",
        "typescript": "^5.6.2",
        "uber-sdk": "file:./packages/uber-sdk"
    },
    "devDependencies": {
        "@viverse/cli": "^0.9.5-beta.6",
        "@wonderlandcloud/cli": "^0.2.11",
        "@wonderlandengine/editor-api": "^1.4.5"
    },
    "overrides": {
        "@wonderlandengine/api": "$@wonderlandengine/api"
    }
}